const ISO_DAY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;
const LEGACY_DAY_PATTERN = /^(\d{2})\/(\d{2})\/(\d{4})$/;

const parseCivilDate = (value: string) => {
  const isoMatch = ISO_DAY_PATTERN.exec(value);
  const legacyMatch = LEGACY_DAY_PATTERN.exec(value);
  const parts = isoMatch
    ? [Number(isoMatch[1]), Number(isoMatch[2]), Number(isoMatch[3])]
    : legacyMatch
      ? [Number(legacyMatch[3]), Number(legacyMatch[2]), Number(legacyMatch[1])]
      : null;

  if (!parts) {
    return null;
  }

  const [year, month, day] = parts;
  const date = new Date(year, month - 1, day);
  return date.getFullYear() === year &&
    date.getMonth() === month - 1 &&
    date.getDate() === day
    ? date
    : null;
};

export const formatI18nDateValue = (value: unknown, locale?: string) => {
  let date: Date | null = null;
  if (value instanceof Date) {
    date = value;
  } else if (typeof value === "string") {
    date = parseCivilDate(value);
    if (!date) {
      const parsed = Date.parse(value);
      if (!Number.isNaN(parsed)) {
        date = new Date(parsed);
      }
    }
  }

  if (!date || Number.isNaN(date.getTime())) {
    return String(value ?? "");
  }

  try {
    return new Intl.DateTimeFormat(locale, {
      year: "numeric",
      month: "short",
      day: "numeric",
    }).format(date);
  } catch {
    return date.toDateString();
  }
};
